import { usePersonalLoan, usePersonalLoanRouteFsm, useProfile } from 'shared/hooks';
import SsnForm from './SsnForm';

const SsnContainer = () => {
  const { profile, error, saveSsn } = useProfile();
  const { uuid } = usePersonalLoan();
  const runRouter = usePersonalLoanRouteFsm();

  const handleSubmit = async (data) => {
    if (!profile.hasSsn) {
      await saveSsn(data);
    }

    runRouter();
  };

  return <SsnForm handleSubmit={handleSubmit} personalLoanUuid={uuid} profile={profile} serverError={error} />;
};

export default SsnContainer;
